import React from "react";
import { createBrokerView } from "app/main/utils/brokerUtils";
import { formatDate } from "app/main/utils/dateUtils";
import { createPriceView } from "app/main/utils/priceUtils";
import TypeComponent from "app/main/searchV3/table-components/TypeComponent";
import { getUserId } from "app/services/LoginService";

const search = {
	urlGET: "api/search/requests/:searchId/details",
	idKey: "tripid",
	listenEvent: "searchRevision",
	segmentKey: "ADMIN_SEARCH_DETAILS",
	cache: {
		key: "search_result_:searchId",
		disableInit: true,
	},
	content: {
		grid: {
			variant: "skinny",
			theme: "light",
			tilesPerRow: 2,
			itemsPerRow: 8,
			mobile: {
				tilesPerRow: 1,
				itemsPerRow: 3,
				layout: [
					["origin", "ready"],
					["destination", "deliverby"],
					["distance_to_origin", "miles", "price"],
				],
			},
		},
		table: {
			variant: "extra-skinny",
			orderBy: ["price", "miles", "distance_to_origin", "distance_to_dest", "weight", "ready"],
		},
		pagination: {
			enabled: true,
			auto: {
				enabled: false,
			},
			resetScroll: true,
			defaut: {
				size: 50,
			},
		},
		order: {
			defaut: {
				key: "distance_to_origin",
				dir: "asc",
			},
		},
		click: {
			dialogBuilder: (item, dataIds) => ({
				viewId: "LOAD_SUGGEST_VIEW",
				dataIds: {
					load: item,
					loadId: item.tripid,
					userId: getUserId(),
					searchId: dataIds.searchId,
					carrierId: item.carrierId,
					truckId: item.truckId,
					historicalView: true,
				},
			}),
		},
		isActive: (item) => true,
		isHighlighted: (item) => {
			if (item.coveredBy) return " bg-blue-50 ";
			if (item.contacted_end || item.email_replied) return " bg-orange-50 ";
			if (item.contacted || item.email_sent) return " bg-red-50 ";
			if (item.seen && !item.deleted) return " bg-orange-50 ";
			return null;
		},
		isCrossed: (item) => !!item?.deleted,
		items: [
			{
				builder: (item) => <TypeComponent item={item} smallScreen={true} />,
				type: "component",
				key: "type",
				label: "Type",
				grid: { headerTitle: true },
			},
			{
				key: "reason",
				label: "Reason",
			},
			{
				builder: (item, dispatch, snackbar) =>
					createBrokerView(item, undefined, dispatch, snackbar, {
						skinny: true,
						showSource: false,
						hideCreditScore: true,
					}),
				key: "clientid",
				type: "component",
				label: "Broker",
				grid: { headerTitle: true },
			},
			{ key: "miles", type: "text", label: "Miles" },
			{ key: "weight", type: "text", label: "Weight" },
			{ key: "distance_to_origin", type: "number", label: "DH-O" },
			{ key: "origin", type: "text", label: "Origin" },
			{
				builder: (item) => formatDate(item.ready, item.pickupby, true, true, true, true),
				key: "ready",
				label: "Pickup",
			},
			{ key: "distance_to_dest", type: "number", label: "DH-D" },
			{ key: "destination", type: "text", label: "Destination" },
			{
				builder: (item) =>
					item.owner === "dat" ? "-" : formatDate(item.dropready, item.deliverby, true, true, true, true),
				key: "deliverby",
				label: "Delivery",
			},
			{
				builder: (item) => createPriceView(item.price),
				key: "price",
				type: "text",
				label: "Rate",
			},
		],
	},
};

export default search;
